import CloseIcon from '~shared/assets/icons/close.svg?react';

import { IconButton } from '@breezeventures/ui-kit/icon-button';

import { BusinessSelect, StoreSelect } from './dashboard-filter-fields';

const FILTER_WIDTH = 'min-w-[180px] flex-1';

type Props = {
  hideMerchantFilter: boolean;
  onFiltersChange: () => void;
  onReset: () => void;
};

export function DashboardFilters({
  hideMerchantFilter,
  onFiltersChange,
  onReset,
}: Props) {
  return (
    <div className="flex flex-wrap items-center gap-2">
      {!hideMerchantFilter && (
        <div className={FILTER_WIDTH}>
          <BusinessSelect onChange={onFiltersChange} />
        </div>
      )}
      <div className={FILTER_WIDTH}>
        <StoreSelect onChange={onFiltersChange} />
      </div>
      <IconButton
        type="button"
        variant="secondary"
        size="l"
        aria-label="Reset filters"
        onClick={onReset}
      >
        <CloseIcon className="size-3.5!" />
      </IconButton>
    </div>
  );
}
